// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"18f248097da5cf72","5285":"ff5f482287b941ad"}[chunkId] + ".css";
};